import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18next';
import moment from 'moment';
import { Container, Row, Button, Col, Form, Input, FormFeedback } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';

import AutoCompleteSearch from '../central/autosearch/AutoCompleteSearch';
import SearchButton from '../common/SearchButton';
import { getEventTrackingLog, getBrandAndRestNames, dispatchErrorMessage, loadAdmins, downloadChanges, getSelectedUser } from '../../actions';
import AdminScreen from '../users/AdminScreen';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../utils/Constants';

class EventTrackingScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenAdminScreen: false,
            restaurantName: '',
            admin: null,
            currentPageNumber: 0,
            isEmptyField: false,
            searchQuery: {
                restaurantId: '',
                actionType: '',
                userName: '',
                date: ''
            }
        }
        this.toggleAdminScreen = this.toggleAdminScreen.bind(this);
        this.search = this.search.bind(this);
        this.changeState = this.changeState.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        this.props.getBrandAndRestNames();
        this.props.getEventTrackingLog(this.state.currentPageNumber, this.state.searchQuery)
    }

    componentWillMount() {
        this.props.loadAdmins();
    }

    downloadChanges(activityId) {
        this.props.downloadChanges(activityId)
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    toggleAdminScreen(userId) {

        const { selectedUser } = this.props;

        if (!this.state.isOpenAdminScreen) {

            this.props.getSelectedUser(userId, () => {
                this.getSelectedUser()
            });
        } else {
            this.setState({
                isOpenAdminScreen: !this.state.isOpenAdminScreen
            });
        }
    }

    getSelectedUser() {
        const { selectedUser } = this.props;

        this.setState({
            isOpenAdminScreen: !this.state.isOpenAdminScreen,
            admin: selectedUser
        });
    }

    search() {
        if (!this.state.isEmptyField) {
            this.props.getEventTrackingLog(this.state.currentPageNumber, this.state.searchQuery);
        }
    }

    clearSearch() {

        this.setState({
            restaurantName: '',
            isEmptyField: false,
            searchQuery: {
                restaurantId: '',
                actionType: '',
                userName: '',
                date: '',
            },
            currentPageNumber: 0
        },
            () => {
                document.getElementById("date").value = '';
                this.props.getEventTrackingLog(this.state.currentPageNumber, this.state.searchQuery);
            });
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getEventTrackingLog(this.state.currentPageNumber, this.state.searchQuery));
    }

    changeState = (e, inputData, inputName) => {

        const names = this.props.ordersLog ? this.props.ordersLog.restaurantNames : null;

        if (!e) {
            this.setState({
                ...this.state,
                currentPageNumber: 0,
                isEmptyField: false,
                searchQuery: {
                    ...this.state.searchQuery,
                    restaurantId: inputData.restaurantId
                },
                [inputName]: inputData[inputName],
                [`${inputName}Data`]: inputData
            });

            return;
        }

        let targetValue = e.target.value;

        if (e.target.name === 'date') {
            targetValue = e.target.value.split(/\D/);
            targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
            targetValue = moment(targetValue).format("DD-MM-YYYY")
        }

        this.setState({
            currentPageNumber: 0,
            [e.target.name]: targetValue,
            searchQuery: {
                ...this.state.searchQuery,
                [e.target.name]: targetValue
            },
        });

        if (names && e.target.name === 'restaurantName') {
            return names.map(name => {
                if (name.restaurantName === targetValue) {
                    this.setState({
                        currentPageNumber: 0,
                        isEmptyField: false,
                        searchQuery: {
                            ...this.state.searchQuery,
                            restaurantId: name.restaurantId
                        },
                    });
                } else if (targetValue === '') {
                    this.setState({
                        currentPageNumber: 0,
                        isEmptyField: false,
                        searchQuery: {
                            ...this.state.searchQuery,
                            restaurantId: ''
                        }
                    });
                } else {
                    this.setState({
                        currentPageNumber: 0,
                        isEmptyField: true,
                        searchQuery: {
                            ...this.state.searchQuery,
                            restaurantId: ''
                        }
                    });
                }
            })
        }

    }

    renderDownloadButton = (activityId) => {

        return (
            <Button color="link" style={{ display: 'flex', alignItems: 'center' }} onClick={() => this.downloadChanges(activityId)}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:eventTrackingScreen.download')}
            </Button>
        )
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={this.props.eventTrackingLog.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.eventTrackingLog.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }


    renderSearch() {
        const { restaurantName } = this.state;
        const { userName, date, actionType } = this.state.searchQuery;
        const { paddingLeftRight } = styles;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }} xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={{ maxWidth: 190, display: 'flex', flexDirection: 'column', padding: 0 }} >
                            <AutoCompleteSearch
                                inputId='restaurantName'
                                inputName='restaurantName'
                                placeholder={i18n.t('screens:generalScreen.restaurantName')}
                                inputValue={restaurantName}
                                isEmptyField={this.state.isEmptyField}
                                inputStyle={{}}
                                changeState={this.changeState}
                                searchValues={this.props.restaurantNames} />
                            <FormFeedback>{i18n.t('screens:eventTrackingScreen.errorMessage')}</FormFeedback>
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="userName" id="userName" placeholder={i18n.t('screens:eventTrackingScreen.userName')} value={userName} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="date" name="date" id="date" placeholder={i18n.t('screens:eventTrackingScreen.date')} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="select" name="actionType" id="actionType" placeholder={i18n.t('screens:eventTrackingScreen.action')} value={actionType} onChange={this.changeState}>
                                <option value=''>{i18n.t('screens:eventTrackingScreen.selectAction')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.pause')}>{i18n.t('screens:eventTrackingScreen.pause')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.unpause')}>{i18n.t('screens:eventTrackingScreen.unpause')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.openingHoursGeneral')}>{i18n.t('screens:eventTrackingScreen.openingHoursGeneral')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.openingHoursCollection')}>{i18n.t('screens:eventTrackingScreen.openingHoursCollection')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.deliverySettings')}>{i18n.t('screens:eventTrackingScreen.deliverySettings')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.daysOff')}>{i18n.t('screens:eventTrackingScreen.daysOff')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.menuCreate')}>{i18n.t('screens:eventTrackingScreen.menuCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.menuChange')}>{i18n.t('screens:eventTrackingScreen.menuChange')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.menuDelete')}>{i18n.t('screens:eventTrackingScreen.menuDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.categoryCreate')}>{i18n.t('screens:eventTrackingScreen.categoryCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.categoryChange')}>{i18n.t('screens:eventTrackingScreen.categoryChange')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.categoryDelete')}>{i18n.t('screens:eventTrackingScreen.categoryDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.productCreate')}>{i18n.t('screens:eventTrackingScreen.productCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.productChange')}>{i18n.t('screens:eventTrackingScreen.productChange')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.productDelete')}>{i18n.t('screens:eventTrackingScreen.productDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.questionCreate')}>{i18n.t('screens:eventTrackingScreen.questionCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.questionChange')}>{i18n.t('screens:eventTrackingScreen.questionChange')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.questionDelete')}>{i18n.t('screens:eventTrackingScreen.questionDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.answerCreate')}>{i18n.t('screens:eventTrackingScreen.answerCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.answerChange')}>{i18n.t('screens:eventTrackingScreen.answerChange')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.answerDelete')}>{i18n.t('screens:eventTrackingScreen.answerDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.refundPartial')}>{i18n.t('screens:eventTrackingScreen.refundPartial')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.refundFull')}>{i18n.t('screens:eventTrackingScreen.refundFull')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.manualAccept')}>{i18n.t('screens:eventTrackingScreen.manualAccept')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.manualReject')}>{i18n.t('screens:eventTrackingScreen.manualReject')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.manualCancel')}>{i18n.t('screens:eventTrackingScreen.manualCancel')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.manualResend')}>{i18n.t('screens:eventTrackingScreen.manualResend')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.promotionCreate')}>{i18n.t('screens:eventTrackingScreen.promotionCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.promotionEdit')}>{i18n.t('screens:eventTrackingScreen.promotionEdit')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.deliveryOpeningHours')}>{i18n.t('screens:eventTrackingScreen.deliveryOpeningHours')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.promotionDelete')}>{i18n.t('screens:eventTrackingScreen.promotionDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.pickupSettings')}>{i18n.t('screens:eventTrackingScreen.pickupSettings')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.dinePaySettings')}>{i18n.t('screens:eventTrackingScreen.dinePaySettings')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.curbsideSettings')}>{i18n.t('screens:eventTrackingScreen.curbsideSettings')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.generalSettings')}>{i18n.t('screens:eventTrackingScreen.generalSettings')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.additionalChargeCreate')}>{i18n.t('screens:eventTrackingScreen.additionalChargeCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.additionalChargeUpdate')}>{i18n.t('screens:eventTrackingScreen.additionalChargeUpdate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.additionalChargeDelete')}>{i18n.t('screens:eventTrackingScreen.additionalChargeDelete')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.additionalChargeCreateCsv')}>{i18n.t('screens:eventTrackingScreen.additionalChargeCreateCsv')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.companyInfoCreate')}>{i18n.t('screens:eventTrackingScreen.companyInfoCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.companyInfoUpdate')}>{i18n.t('screens:eventTrackingScreen.companyInfoUpdate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.bankAccountCreate')}>{i18n.t('screens:eventTrackingScreen.bankAccountCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.bankAccountUpdate')}>{i18n.t('screens:eventTrackingScreen.bankAccountUpdate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.restaurantSubscriptionCreate')}>{i18n.t('screens:eventTrackingScreen.restaurantSubscriptionCreate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.restaurantSubscriptionUpdate')}>{i18n.t('screens:eventTrackingScreen.restaurantSubscriptionUpdate')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.activateRestaurant')}>{i18n.t('screens:eventTrackingScreen.activateRestaurant')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.deactivateRestaurant')}>{i18n.t('screens:eventTrackingScreen.deactivateRestaurant')}</option>
                                <option value={i18n.t('screens:eventTrackingScreen.addRestaurantNote')}>{i18n.t('screens:eventTrackingScreen.addRestaurantNote')}</option>
                            </Input>
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                            <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}>{i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        )
    }

    renderTable() {
        const { eventTrackingLog } = this.props
        const { headerContainer } = styles

        return (
            <Col style={{ padding: '0px' }}>
                <Row style={headerContainer}>
                    <Col xs={2}>{i18n.t('screens:eventTrackingScreen.brand')}</Col>
                    <Col xs={2}>{i18n.t('screens:eventTrackingScreen.restaurant')}</Col>
                    <Col xs={2}>{i18n.t('screens:eventTrackingScreen.date')}</Col>
                    <Col xs={1}>{i18n.t('screens:eventTrackingScreen.userName')}</Col>
                    <Col xs={2}>{i18n.t('screens:eventTrackingScreen.userRole')}</Col>
                    <Col xs={1}>{i18n.t('screens:eventTrackingScreen.changes')}</Col>
                    <Col xs={2}>{i18n.t('screens:eventTrackingScreen.action')}</Col>
                </Row>
                {
                    eventTrackingLog.content && eventTrackingLog.content.length ?
                        this.renderTableRows() :
                        <Col style={{ width: '90%', padding: '15px 15px 0', borderBottom: '1px solid #dee2e6' }}>
                            <p style={{ fontSize: '14px' }}>{i18n.t('screens:centralOrdersLog.noResults')}</p>
                        </Col>
                }
                <Col style={{ paddingRight: '0px' }}>{this.renderPagination()}</Col>
            </Col>
        );
    }

    renderTableRows() {

        const { headerContainer } = styles;
        const content = this.props.eventTrackingLog.content ? this.props.eventTrackingLog.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((order, i) => {
                let orderAction = order.action.replace(/_/g, ' ');
                let userRole = order.userRole.replace(/_/g, ' ');

                return (
                    <Row key={i} style={headerContainer}>
                        <Col xs={2}>{order.brandName}</Col>
                        <Col xs={2}>{order.restaurantName}</Col>
                        <Col xs={2}>{order.date}</Col>
                        <Col xs={1}>
                            {
                                order.userId === -225 ?
                                    <div style={{fontSize: 14, display: 'inline-block', whiteSpace: 'nowrap'}}>
                                        {order.userName}
                                    </div> :
                                    <Button color="link" onClick={() => this.toggleAdminScreen(order.userId)}>
                                        {order.userName}
                                    </Button>
                            }
                        </Col>
                        <Col xs={2}>{userRole}</Col>
                        <Col xs={1} style={{ display: 'flex', justifyContent: 'center' }}>{this.renderDownloadButton(order.id)}</Col>
                        <Col xs={2}>{orderAction}</Col>
                    </Row>
                )
            })
        }
    }


    render() {

        return (
            <Container fluid style={{ width: '96%', marginTop: '20px', paddingLeft: '15px' }}>
                <Row>{this.renderSearch()}</Row>
                <Row>{this.renderTable()}</Row>
                <AdminScreen
                    styles={styles}
                    isOpen={this.state.isOpenAdminScreen}
                    onToggle={this.toggleAdminScreen}
                    admin={this.state.admin}
                    dispatchMessage={this.props.dispatchErrorMessage}
                    isEventTrackingScreen={true} />
            </Container>
        );
    }
}

const mapStateToProps = state => {

    return {
        restaurantNames: state.ordersLog.restaurantNames,
        eventTrackingLog: state.eventTrackingLog.log,
        selectedUser: state.eventTrackingLog.selectedUser,
        ordersLog: state.ordersLog,
        admins: state.admins,
    }
};

export default connect(mapStateToProps, {
    getEventTrackingLog,
    getBrandAndRestNames,
    dispatchErrorMessage,
    loadAdmins,
    downloadChanges,
    getSelectedUser
})(EventTrackingScreen);

let styles = {
    headerContainer: {
        width: '100%',
        height: '45px',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        backgroundColor: '#F8F8F8'
    },
    paddingLeftRight: {
        maxWidth: '180px',
        paddingLeft: 5,
        paddingRight: 0,
        marginBottom: 5
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/eventTracking/EventTrackingScreen.js